<template>
  <keep-alive include="MerchantsList">
    <router-view ></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "Merchants",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
